import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import { MdOutlineClose } from 'react-icons/md'

const ProductView = () => {
  const { productId } = useParams()

  const [productData, setProductData] = useState(null)
  const [loading, setLoading] = useState(true)

  const fetchProductData = async () => {
    try {
      const response = await axiosAuthInstance.get(
        `product/detail/${productId}`,
      )
      setProductData(response.data.result)
    } catch (error) {
      console.error('Error fetching Product data:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchProductData()
  }, [productId])

  const handleRemovePreview = async (img) => {
    try {
      const response = await axiosAuthInstance.put(
        `product/remove-img/${productId}`,
        { img },
      )

      if (response && response.status === 200) {
        fetchProductData()
      }
    } catch (error) {
      console.error('Error fetching Product data:', error)
    }
  }

  if (loading) {
    return <div>Loading...</div>
  }

  if (!productData) {
    return <div>No Product data found.</div>
  }

  return (
    <div className='p-4'>
      <div className='bg-white text-black shadow-md rounded-lg p-6'>
        <h2 className='text-xl font-semibold mb-4'>Company Product Details</h2>
        <div className='overflow-x-auto'>
          <table className='table-auto w-full border-collapse'>
            <tbody>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Company Name</td>
                <td className='border-b px-4 py-2'>
                  {productData.company.name}
                </td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Product Name</td>
                <td className='border-b px-4 py-2'>{productData.name}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Size</td>
                <td className='border-b px-4 py-2'>{productData.size.size}</td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Finish</td>
                <td className='border-b px-4 py-2'>
                  {productData.finish.name}
                </td>
              </tr>
              {productData?.series?.name && (
                <tr>
                  <td className='border-b px-4 py-2 font-medium'>Series</td>
                  <td className='border-b px-4 py-2'>
                    {productData.series.name}
                  </td>
                </tr>
              )}

              {productData?.thickness && (
                <tr>
                  <td className='border-b px-4 py-2 font-medium'>Thickness</td>
                  <td className='border-b px-4 py-2'>
                    {productData.thickness}
                  </td>
                </tr>
              )}

              {productData?.isBorder && (
                <tr>
                  <td className='border-b px-4 py-2 font-medium'>Is Border</td>
                  <td className='border-b px-4 py-2'>{productData.isBorder ? "Yes" : "No"}</td>
                </tr>
              )}

              {productData?.borderColor && (
                <tr>
                  <td className='border-b px-4 py-2 font-medium'>
                    Border Color
                  </td>
                  <td className='border-b px-4 py-2'>
                    {productData.borderColor}
                  </td>
                </tr>
              )}

              {productData?.isBorderShadow && (
                <tr>
                  <td className='border-b px-4 py-2 font-medium'>
                    Is Border Shadow
                  </td>
                  <td className='border-b px-4 py-2'>
                    {productData.isBorderShadow ? "Yes" : "No"}
                  </td>
                </tr>
              )}

              {productData?.borderShadowColor && (
                <tr>
                  <td className='border-b px-4 py-2 font-medium'>
                    Border Shadow Color
                  </td>
                  <td className='border-b px-4 py-2'>
                    {productData.borderShadowColor}
                  </td>
                </tr>
              )}

              {productData?.isActive && (
                <tr>
                  <td className='border-b px-4 py-2 font-medium'>Is Active</td>
                  <td className='border-b px-4 py-2'>{productData.isActive ? "Yes" : "No"}</td>
                </tr>
              )}

              {productData?.bodyType && (
                <tr>
                  <td className='border-b px-4 py-2 font-medium'>Body Type</td>
                  <td className='border-b px-4 py-2'>{productData.bodyType}</td>
                </tr>
              )}

              <tr>
                <td className='border-b px-4 py-2 font-medium'>Cover Photo</td>
                <td className='border-b px-4 py-2'>
                  {productData.cover_photo ? (
                    <img
                      src={productData.cover_photo}
                      alt='product cover Photo'
                      className='my-2 w-24 h-24 sm:w-32 sm:h-32 object-contain'
                    />
                  ) : (
                    <span> No Photo available </span>
                  )}
                </td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>
                  Product Preview Image
                </td>
                <td className='border-b px-4 py-2'>
                  {productData.product_preview_image ? (
                    <img
                      src={productData.product_preview_image}
                      alt='Product Preview Image'
                      className='my-2 w-24 h-24 sm:w-32 sm:h-32 object-contain'
                    />
                  ) : (
                    <span> No Photo available </span>
                  )}
                </td>
              </tr>
              <tr>
                <td className='border-b px-4 py-2 font-medium'>Randoms</td>
                <td className='border-b px-4 py-2'>
                  {productData.randoms && productData.randoms.length > 0 ? (
                    <div className='flex gap-4'>
                      {productData.randoms.map((image, index) => (
                        <div
                          key={index}
                          className='relative inline-block mr-4 mt-4'
                        >
                          <img
                            src={image}
                            alt={`Random Image ${index + 1}`}
                            className='w-16 h-16 sm:w-24 sm:h-24 object-contain border rounded'
                          />
                          <MdOutlineClose
                            onClick={() => handleRemovePreview(image)}
                            className='absolute top-0 right-0 text-white bg-black bg-opacity-50 p-1 rounded-full cursor-pointer text-xl'
                          />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <span>No Images Available</span>
                  )}
                </td>
              </tr>
              {productData.separator && (
                <tr>
                  <td className='border-b px-4 py-2 font-medium'>Separator</td>
                  <td className='border-b px-4 py-2'>
                    <img
                      src={productData.separator}
                      alt='Product Separator'
                      className='my-2 w-24 h-24 sm:w-32 sm:h-32 object-contain'
                    />
                  </td>
                </tr>
              )}
              {productData?.series && (
                <>
                  <tr>
                    <td className='border-b px-4 py-2 font-medium'>Series</td>
                    <td className='border-b px-4 py-2'>
                      {productData.series.name}
                    </td>
                  </tr>
                  <tr>
                    <td className='border-b px-4 py-2 font-medium'>
                      Series Logo
                    </td>
                    <td className='border-b px-4 py-2'>
                      <img
                        src={productData.series.logo}
                        alt='Series Logo'
                        className='my-2 w-24 h-24 sm:w-32 sm:h-32 object-contain'
                      />
                    </td>
                  </tr>
                </>
              )}

              {productData.light && (
                <tr>
                  <td className='border-b px-4 py-2 font-medium'>Light</td>
                  <td className='border-b px-4 py-2'>
                    <img
                      src={productData.light}
                      alt='Light'
                      className='my-2 w-24 h-24 sm:w-32 sm:h-32 object-contain'
                    />
                  </td>
                </tr>
              )}

              {productData.dark && (
                <tr>
                  <td className='border-b px-4 py-2 font-medium'>Dark</td>
                  <td className='border-b px-4 py-2'>
                    <img
                      src={productData.dark}
                      alt='Dark'
                      className='my-2 w-24 h-24 sm:w-32 sm:h-32 object-contain'
                    />
                  </td>
                </tr>
              )}

              {productData.mobileSurface && (
                <tr>
                  <td className='border-b px-4 py-2 font-medium'>Mobile Surface</td>
                  <td className='border-b px-4 py-2'>
                    <img
                      src={productData.mobileSurface}
                      alt='Mobile Surface'
                      className='my-2 w-24 h-24 sm:w-32 sm:h-32 object-contain'
                    />
                  </td>
                </tr>
              )}

              {productData.hl && (
                <tr>
                  <td className='border-b px-4 py-2 font-medium'>HL</td>
                  <td className='border-b px-4 py-2'>
                    <img
                      src={productData.hl}
                      alt='HL'
                      className='my-2 w-24 h-24 sm:w-32 sm:h-32 object-contain'
                    />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default ProductView
